import { logger } from "logger";
import config from "../../config/config";
import { useAuthContext } from "../Auth";
import { FC, useEffect, useState } from "react";
import { DefaultGenerics, StreamChat } from "stream-chat";
import { Chat } from "stream-chat-react";
import { PartnerFeatures } from "shared/types/partner";

export const ChatProvider: FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [client, setClient] = useState<null | StreamChat<DefaultGenerics>>(
    null
  );
  const { auth, partner, partnerFeatures } = useAuthContext();
  const hasChat = partnerFeatures.includes(PartnerFeatures.Chat);

  useEffect(() => {
    if (auth?.id && partner && hasChat) {
      const client = StreamChat.getInstance(config.streamApiKey);

      client
        .connectUser(
          {
            id: auth.stream_chat_id || "",
            name: auth.name
          },
          auth.stream_chat_token
        )
        .then(() => {
          setClient(client);
        })
        .catch((e) => {
          logger.error("Error connecting to Stream Chat", e);
        });

      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      if (client)
        return () => {
          client.disconnectUser();
        };
    }
  }, [auth?.id, partner, hasChat]);

  if (!client) return children;

  return (
    <Chat client={client} theme="messaging light">
      {children}
    </Chat>
  );
};
